import React from "react";

const Arrow = ({ daysLeft }: { daysLeft: number }) => {
  const daysLeftClass = (daysLeft < 3) ? "s1_small s1_red" : "text-sublabel";

  return <div className="margin-left margin-right flex align-center" >
    <div>
      <div className="s1_gray margin-bottom-small " style={{ fontSize: 25, textAlign: "center" }}>➔</div>
      <div className={daysLeftClass}>{`${daysLeft} d`}</div>
    </div>
  </div>;
};

export default Arrow;